const DYNAMICS_HOST_PATTERN = /^[\w-]+\.crm[\w]*\.dynamics\.com$/i;

export const parseDynamicsInstanceUrl = (input: string): string => {
    const trimmed = input.trim();
    if (!trimmed) {
        return trimmed;
    }

    try {
        const url = new URL(trimmed.includes("://") ? trimmed : `https://${trimmed}`);

        if (DYNAMICS_HOST_PATTERN.test(url.hostname)) {
            return `https://${url.hostname.toLowerCase()}`;
        }
    } catch {
        // Not a valid URL — return the raw input for manual editing.
    }

    return trimmed;
};

export const isValidDynamicsInstanceUrl = (url: string): boolean => {
    const trimmed = url.trim();
    if (!trimmed) {
        return false;
    }

    try {
        const parsed = new URL(trimmed);

        return (
            parsed.protocol === "https:" &&
            DYNAMICS_HOST_PATTERN.test(parsed.hostname) &&
            (parsed.pathname === "/" || parsed.pathname === "")
        );
    } catch {
        return false;
    }
};
